import React, { useState } from "react";
import InitialLogo from "../../../Assets/Images/InitialLogo.png";
const ClickableChip = ({
  totalData,
  title,
  textClass,
  isSVG,
  SVG,
  imgClass,
  selected,
  handleClick,
}) => {
  const isSelected = selected?.categoryName === title;
  const [imgError, setImgError] = useState(false);
  const handleImageError = () => {
    setImgError(true); // Set imgError state to true when image loading fails
  };
  const DefaultStyles =
    "py-1 px-3 flex items-center gap-2 rounded-md cursor-pointer";
  const StyleConditioning = isSelected
    ? "border border-transparent bg-secondary text-white"
    : "border border-debatePalette-buttonBorder";
  return (
    <div
      id={title}
      className={` ${DefaultStyles} ${StyleConditioning}`}
      onClick={handleClick}
    >
      <p
        className={`${
          isSelected
            ? "text-debatePalette-background"
            : "text-debatePalette-bodyText"
        } text-sm text-inherit ${textClass}`}
      >
        {title}
      </p>
      {isSVG ? (
        <SVG
          className={`${
            isSelected
              ? "text-debatePalette-background"
              : "text-debatePalette-bodyText"
          }  h-4 w-4 ${imgClass}`}
        />
      ) : imgError ? (
        <img
          src={InitialLogo}
          alt={"Logo"}
          className={`w-4 h-4 ${imgClass}`}
          onError={handleImageError}
        />
      ) : (
        <img
          src={SVG}
          className={`w-4 h-4 ${imgClass}`}
          alt={title}
          onError={handleImageError}
        />
      )}

      <p
        className={`${
          isSelected
            ? "text-debatePalette-background"
            : "text-debatePalette-bodyText"
        } text-sm text-inherit ${textClass}`}
      >
        ({totalData})
      </p>
    </div>
  );
};

export default ClickableChip;
